<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { useLogActivityStore } from "@/stores/management/log-activity";
import { formatDateTime } from "@/utils/helper";

const headers: Header[] = [
  { text: "User", value: "user_name" },
  { text: "Module", value: "module" },
  { text: "Action", value: "action" },
  { text: "Description", value: "description" },
  { text: "Date", value: "created_at" },
];

const logActivityStore = useLogActivityStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalData = ref<number>(0);
const listLog = ref<any>([]);
const isLoading = ref(false);

const loadDataItems = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await logActivityStore.dispatchGetList(
    page.value,
    limit.value,
    query
  );

  if (success) {
    listLog.value = await logActivityStore.logs.items;
    page.value = await logActivityStore.logs.page;
    limit.value = await logActivityStore.logs.pageSize;
    totalData.value = await logActivityStore.logs.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataItems();
};

loadDataItems();
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        <h3 class="mb-0">Log Activity User</h3>
      </div>
      <FilterTable @searchByQuery="loadDataItems" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listLog"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalData"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-created_at="props">
            {{ formatDateTime(props.created_at) }}
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>
</template>
<style>
.image-item {
  width: 200px;
  height: auto;
  object-fit: contain;
  padding: 10px;
}
</style>
